import React from 'react'
import { Input, message, notification } from 'antd'
import orderApi from '../../../Order/apiService'
import { trans } from '../../../../system/i18n'

const LinkOrderByOwnerLess = ({ packageInfo, fetchBarcodePackages, filter }) => {
    const { barcode, id, id_partner } = packageInfo
    const [ownerLessCode, setOwnerLessCode] = React.useState('')

    const handleSubmit = () => {
        orderApi.linkOrderByOwnerLess(id, { owner_less_code: ownerLessCode, freight_bill_code: barcode }).then(res => {
            fetchBarcodePackages(filter)
        }).catch(() => {
            notification.message({ message: trans('message.update_failed') })
        })
    }
    if (id_partner !== 3) return null;

    return (
        <div className="owner_less_code link-order-auto">
            <Input
                className={`a-input a-input--matching-code _package_matching_code`}
                style={{ height: 'auto', marginRight: '8px' }}
                placeholder="Owner less code"
                value={ownerLessCode}
                onPressEnter={handleSubmit}
                onChange={e => setOwnerLessCode(e.target.value)}
            />
        </div>
    )
}

export default LinkOrderByOwnerLess
